import script from "./UserLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLogin.vue?vue&type=script&setup=true&lang=js"

import "./UserLogin.vue?vue&type=style&index=0&id=3b7c8d96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b7c8d96"]])

export default __exports__